import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { InformationSvg } from './InformationSvg'

export const EaInformationIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={InformationSvg} {...props} />
)
